import i18n from "src/services/i18n";
import { MENU_CODE } from "src/helpers/constant";

export const MENU = [
  //#region Profile
  {
    title: i18n.t("side_bar.profile_management"),
    icon: "briefcase",
    type: "sub",
    code: MENU_CODE.PROFILE_DETAIL,
    active: false,
    children: [
      {
        path: "/profile",
        title: i18n.t("side_bar.company_profile"),
        // title: i18n.t("side_bar.profile_detail"),
        code: MENU_CODE.PROFILE_DETAIL,
        type: "link",
      },
    ],
  },
  //#endregion

  //#region Admins
  // {
  //   title: i18n.t("side_bar.admins"),
  //   icon: "user",
  //   type: "sub",
  //   active: false,
  //   children: [
  //     {
  //       title: i18n.t("page_admin_list.page_title"),
  //       path: "/admins",
  //       type: "link",
  //     },
  //   ],
  // },
  //#endregion

  //#region Users
  {
    title: i18n.t("side_bar.user_management"),
    icon: "user",
    type: "sub",
    code: MENU_CODE.USER,
    active: false,
    children: [
      {
        path: "/users",
        title: i18n.t("side_bar.user_list"),
        type: "link",
        code: MENU_CODE.USER,
      },
    ],
  },
  //#endregion

  //#region Groups
  {
    title: i18n.t("side_bar.group_management"),
    icon: "users",
    type: "sub",
    code: MENU_CODE.GROUP,
    active: false,
    children: [
      {
        path: "/groups",
        title: i18n.t("side_bar.group_list"),
        type: "link",
        code: MENU_CODE.GROUP_LIST,
      },
      {
        path: "/groups/add",
        title: i18n.t("side_bar.group_add"),
        type: "link",
        code: MENU_CODE.GROUP_ADD,
      },
    ],
  },
  //#endregion

  //#region Plans
  {
    title: i18n.t("side_bar.plan_management"),
    icon: "book",
    type: "sub",
    code: MENU_CODE.PLAN,
    active: false,
    children: [
      {
        path: "/plans",
        title: i18n.t("side_bar.plan_detail"),
        type: "link",
        code: MENU_CODE.PLAN_DETAIL,
      },
      {
        path: "/plans/change",
        title: i18n.t("side_bar.plan_change"),
        type: "link",
        code: MENU_CODE.PLAN_CHANGE,
      },
      {
        path: "/licenses/change",
        title: i18n.t("side_bar.license_change"),
        type: "link",
        code: MENU_CODE.LICENSE_CHANGE,
      },
      {
        path: "/showroom-external-concurrent-access/change",
        title: i18n.t("side_bar.guest_access_license_change"),
        type: "link",
        code: MENU_CODE.GUEST_ACCESS_CHANGE,
      },
      {
        path: "/storages",
        title: i18n.t("side_bar.storage_list"),
        type: "link",
        code: MENU_CODE.STORAGE_LIST,
      },
      {
        path: "/plans/stop",
        title: i18n.t("side_bar.request_stop_service"),
        type: "link",
        code: MENU_CODE.REQUEST_STOP_SERVICE,
      },
    ],
  },
  //#endregion

  //#region Payment
  {
    title: i18n.t("side_bar.payment_management"),
    icon: "credit-card",
    type: "sub",
    code: MENU_CODE.PAYMENT,
    active: false,
    children: [
      {
        path: "/payments",
        title: i18n.t("side_bar.payment_history"),
        type: "link",
        code: MENU_CODE.PAYMENT_HISTORY,
      },
      {
        path: "/card/add",
        title: i18n.t("side_bar.payment_card"),
        type: "link",
        code: MENU_CODE.PAYMENT_CARD,
      },
    ],
  },
  //#endregion

  //#region Security
  {
    title: i18n.t("side_bar.security_management"),
    icon: "lock",
    type: "link",
    code: MENU_CODE.SECURITY,
    active: false,
    path: "/security",
    // children: [
    //   {
    //     path: "/security",
    //     title: i18n.t("side_bar.security"),
    //     type: "link",
    //   },
    // ],
  },
  //#endregion

  //#region PR Channel
  {
    title: i18n.t("side_bar.pr_channel"),
    icon: "tv",
    type: "sub",
    code: MENU_CODE.PR_CHANNEL,
    active: false,
    children: [
      {
        path: "/pr-channels",
        title: i18n.t("pr_channel_list"),
        type: "link",
        code: MENU_CODE.PR_CHANNEL_LIST
      },
      {
        path: "/pr-channels/add",
        title: i18n.t("create_pr_channel"),
        type: "link",
        code: MENU_CODE.CREATE_PR_CHANNEL
      },
    ],
  },
  //#endregion

  //#region Rooms
  {
    title: i18n.t("side_bar.rooms"),
    icon: "package",
    type: "sub",
    code: MENU_CODE.ROOMS,
    active: false,
    children: [
      // {
      //   path: "/purchased-rooms",
      //   title: i18n.t("side_bar.purchased_rooms"),
      //   type: "link",
      //   active: false,
      //   code: MENU_CODE.ROOM_LIST,
      // },
      // {
      //   path: "/rooms",
      //   title: i18n.t("page_room_list.page_title"),
      //   type: "link",
      //   code: MENU_CODE.ROOM_LIST,
      // },
      {
        path: "/list-rooms",
        title: i18n.t("side_bar.room_list"),
        type: "link",
        code: MENU_CODE.ROOM_LIST,
      },
      // {
      //   path: "/rooms/add",
      //   title: i18n.t("page_room_add.page_title"),
      //   type: "link",
      // },
      {
        path: "/3d-room-space/change",
        title: i18n.t("side_bar.room_space_license_change"),
        type: "link",
        code: MENU_CODE.ROOM_SPACE_CHANGE,
      },
      // {
      //   path: "/rooms/3d-assets",
      //   title: i18n.t("side_bar.room_3d_assets"),
      //   type: "link",
      //   code: MENU_CODE.ROOM_3D_ASSETS,
      // },
      // {
      //   path: "/rooms/statistics",
      //   title: i18n.t("side_bar.statistics"),
      //   type: "link",
      // },
      {
        path: "/guest-verification",
        title: i18n.t("side_bar.guest_verification"),
        type: "link",
        code: MENU_CODE.GUEST_VERIFICATION,
      },
      {
        title: i18n.t("side_bar.room_shop"),
        type: "link",
        active: false,
        path: "/template-rooms/shop",
        code: MENU_CODE.ROOM_OBJECT_SHOP,
      },
    ],
  },
  // {
  //   title: i18n.t("side_bar.rooms_trial"),
  //   icon: "package",
  //   type: "sub",
  //   active: false,
  //   children: [
  //     {
  //       path: "/rooms",
  //       title: i18n.t("page_room_list.page_title"),
  //       type: "link",
  //     },
  //     {
  //       path: "/3d-room-space/change",
  //       title: i18n.t("side_bar.room_space_license_change"),
  //       type: "link",
  //     }
  //   ],
  // },
  //#endregion

  //#region Room Items

  {
    title: i18n.t("side_bar.room_items"),
    icon: "box",
    type: "sub",
    code: MENU_CODE.ROOM_OBJECTS,
    active: false,
    children: [
      // {
      //   path: "/purchased-objects",
      //   title: i18n.t("side_bar.purchased_items"),
      //   type: "link",
      //   active: false,
      //   code: MENU_CODE.ROOM_OBJECTS,
      // },
      // {
      //   path: "/company-objects",
      //   title: i18n.t("side_bar.original_items_list"),
      //   type: "link",
      //   active: false,
      //   code: MENU_CODE.ROOM_OBJECTS,
      // },
      {
        path: "/list-objects",
        title: i18n.t("side_bar.object_list"),
        type: "link",
        active: false,
        code: MENU_CODE.ROOM_OBJECTS,
      },
      {
        path: "/register-objects",
        title: i18n.t("side_bar.register_object"),
        type: "link",
        active: false,
        code: MENU_CODE.ROOM_OBJECTS,
      },
      {
        title: i18n.t("side_bar.items_shopping"),
        type: "link",
        active: false,
        path: "/room-objects/shopping",
        code: MENU_CODE.ROOM_OBJECT_SHOP,
      },
    ],
  },
  //#endregion

  //#region empaty Drive
  {
    title: i18n.t("side_bar.empaty_drive"),
    icon: "hard-drive",
    type: "sub",
    code: MENU_CODE.EMPATY_DRIVE,
    active: false,
    children: [
      {
        path: "/empaty-drive/shared",
        title: i18n.t("side_bar.share_folder"),
        type: "link",
        active: false,
      },
      {
        path: "/empaty-drive/personal",
        title: i18n.t("side_bar.personal"),
        type: "link",
        active: false,
      },
    ],
  },
  //#endregion

  //#region Permissions
  {
    title: i18n.t("side_bar.operator_management"),
    icon: "user",
    type: "sub",
    code: MENU_CODE.OPERATOR_MANAGEMENT,
    active: false,
    children: [
      {
        title: i18n.t("side_bar.operator_group"),
        icon: "file",
        type: "link",
        active: false,
        path: "/operator-group",
        code: MENU_CODE.OPERATOR_GROUP,
      },
      {
        title: i18n.t("side_bar.operator"),
        icon: "file",
        type: "link",
        active: false,
        path: "/operator",
        code: MENU_CODE.OPERATOR,
      },
    ],
  },
  //#endregion
];
